// CANONICAL COPY (GH #7115). src/constants/obligations/obl-physical-security.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-physical-security',
  title: 'Verify physical security perimeters and entry controls',
  description:
    'Confirm that security perimeters, entry controls and protections for offices, rooms and facilities are defined and implemented with strength proportionate to the value of the information assets inside. Secure areas shall be protected by appropriate entry controls so that only authorised personnel are allowed access, and offices, rooms and facilities housing sensitive information shall have physical protection measures designed and implemented to suit their security requirements. Review the physical security policy, perimeter design documentation and entry authorisation records.',
  category: 'assets',
  scfIds: ['SCF-PHY-001', 'SCF-PHY-002', 'SCF-PHY-003'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Physical security policy is published' },
    { type: 'document-within-sla', description: 'Policy review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
